/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitResolutionTypes } from './MonitResolutionTypes';
import {
    MonitResolutionTypesFromJSON,
    MonitResolutionTypesFromJSONTyped,
    MonitResolutionTypesToJSON,
} from './MonitResolutionTypes';

/**
 * 
 * @export
 * @interface ResolutionTypes
 */
export interface ResolutionTypes {
}

/**
 * Check if a given object implements the ResolutionTypes interface.
 */
export function instanceOfResolutionTypes(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResolutionTypesFromJSON(json: any): ResolutionTypes {
    return ResolutionTypesFromJSONTyped(json, false);
}

export function ResolutionTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolutionTypes {
    return json;
}

export function ResolutionTypesToJSON(value?: ResolutionTypes | null): any {
    return value;
}

